module.exports = __webpack_public_path__ + "static/media/weddingEvent.d96182c3.jpeg";